<div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">
        Crear reporte de trabajo
    </h4>
    <button type="button" class="close" aria-label="Close" (click)="ngbActiveModal.close()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    <form [formGroup]="reportForm">
        <div class="form-group">
            <label for="report" class="form-label">Reporte</label>
            <input type="text" class="form-control" id="report" formControlName="report">
        </div>
        <p *ngIf="reportForm.controls['report'].touched && reportForm.controls['report'].invalid" class="text-danger">
            Este campo es requerido</p>
        <div class="form-group">
            <label for="jobName" class="form-label">Frecuencia</label>
            <select id="frecuence" class="form-control" formControlName="frecuence">
                <option value="" disabled>Selecciona frecuencia</option>
                <option value="Diaria">Diaria</option>
                <option value="Semanal">Semanal</option>
                <option value="Quincenal">Quincenal</option>
                <option value="Mensual">Mensual</option>
                <option value="Trimestral">Trimestral</option>
                <option value="Anual">Anual</option>
            </select>
        </div>
        <p *ngIf="reportForm.controls['frecuence'].touched && reportForm.controls['frecuence'].invalid"
            class="text-danger">
            Este campo es requerido</p>
    </form>
</div>
<div class="modal-footer">
    <div class="btn-group w-100" role="group">
        <button type="button" class="btn btn-secondary" (click)="ngbActiveModal.close()" [disabled]="isSaving">
            <span>Cancelar</span>
        </button>
        <button type="button" class="btn btn-success"
            [disabled]="reportForm.invalid || isSaving" (click)="save()">
            <span>Guardar</span>
            <div class="spinner-border" role="status" *ngIf="isSaving">
                <span class="visually-hidden"></span>
            </div>
        </button>
    </div>
</div>